<template>
  <div></div>
</template>

<script>
var FileSaver = require("file-saver");

import moment from "moment";
import Base64 from "base-64";
import md5 from 'js-md5';
import JwtDecode from 'jwt-decode'

moment.locale("pt-br");

export default {
  name: "fct",
  data() {
    return {};
  },

  mounted() {},
  methods: {

    getLocation(type){
      var hostname = window.location;

      type = (type ? type : 'hostname');

      return hostname[type]

      return '';
    },

    random(min, max) {
      return Math.random() * (max - min) + min;
    },

    arrFindByField(arr, field, value) {
      if (!field || !arr || !arr.length > 0) return null;

      var arr = arr.filter(x => x[field] == value);

      if (arr.length == 1) return arr[0];

      return null;
    },

    onlyNumber(value) {
      if (!value) return "";

      return value.replace(/[\. ,:-]+/g, "-").replace(/[^0-9\.]+/g, "");
    },

    onlyText(value) {
      if (!value) return "";

      value = this.toString(value);
      return value.replace(/(<([^>]+)>)/gi, "");
    },

    tempoSessao() {
      var 
        jwt = null,
        iat = 0,
        exp = 0;

      try {
        jwt = JwtDecode(this.jwt);
      } catch (error) {
        jwt = null;
      }

      if(jwt) {
        exp = this.toDate(jwt.exp * 1000, false, "YYYY-MM-DD HH:mm:ss");

        var diffSecs = Math.abs(this.diffDays(null, exp, "s")).toFixed(0);

        var hours = Math.floor(diffSecs / 3600);
        var minutes = Math.floor((diffSecs - hours * 3600) / 60);

        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;

        return hours + "h " + minutes + "m";
      }

      return "00h 00m";
    },

    stringToArray(string) {
      if (!string) return [];

      return JSON.parse(string);
    },

    toFormUpload(form) {
      var data = new FormData();

      for (var key in form) {
        data.append(key, (form[key] != null ? form[key] : ''));
      }

      return data;
    },

    toJoin(data){

      var retorno = '';

      if(typeof data == 'object'){
        for (var key in data) {
          retorno += key+": "+data[key]+"\n"
        }
      }
      else if(typeof data == 'array'){
        retorno = data.join('\n')
      }
      else{
        retorno = data;
      }

      return retorno;
    },

    textSpace(text){
      try {
        text = this.toString(text).split(' ');
        return text[0];
      } 
      catch (error) {
        return text;
      }
      
    },

    booleanToInteger(form) {
      for (var key in form) {
        if (form[key] === true) form[key] = 1;

        if (form[key] === false) form[key] = 0;
      }

      return form;
    },

    base64Decode(value) {
      try {
        return Base64.decode(value);
      } catch (err) {
        return null;
      }
    },

    base64Encode(value) {
      try {
        return Base64.encode(value);
      } catch (err) {
        return null;
      }
    },

    utf8Decode(t) {
      if (!t) return t;

      try {
        return decodeURIComponent(escape(t));
      } catch (err) {
        return t;
      }
    },

    intervaloMes(mes, ano) {
      if (!mes || !ano) {
        mes = new Date().getMonth() + 1;
        ano = new Date().getFullYear();
      }

      var data = new Date(ano + "-" + mes + "-01");
      return data;
    },

    now() {
      return moment().format("dddd");
    },

    toDate(date, disableHours, format) {
      if (!date) {
        date = new Date();
      }

      if (!format) {
        format = "DD/MM/YYYY HH:mm:ss";

        if (disableHours) {
          format = "DD/MM/YYYY";
        }
      }

      return moment(date).format(format);
    },

    convertDate(date,format) {
      if (!date) {
        return new Date();
      }

      format = (format ? format : 'DD/MM/YYYY');

      return moment(date).format(format);
    },

  
    moneyToFloat(value) {
      if (!value || value == "") {
        return 0;
      }

      value = this.toString(value);

      return parseFloat(value.replace(".", "").replace(",", "."));
    },

    floatToMoney(value) {
      if (!value) {
        return "0,00";
      }

      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      });

      value = formatter
        .format(value)
        .replace("R$", "")
        .trim();

      return value;
    },

    formataCampo(text,left,format){

      format = (!format ? '0' : format);
      left = (!left ? 0 : left);

      if(!text)return text;

      return text.toString().padStart(left,format);
    },

    formataRevisao(data){

      var retorno = [], tmpEmp = [];

      for (let i = 0; i < data.length; i++) {
        const element = data[i];

        if(element.empresa && element.fdt){
          var key = element.empresa.id+'_'+element.fdt.id;
          
          if(tmpEmp.indexOf(key) == -1){
            tmpEmp.push(key);
            retorno.push({
              id:key,
              label: element.empresa.nome+' :: '+element.fdt.pcmso+' ('+element.fdt.descricao+')',
              options:[]
            });
          }

          retorno[tmpEmp.indexOf(key)]['options'].push(element);
        }
        
      }
      return retorno;
    },

    addDate(value, date, type, utc) {

      if(!date) {
        date = new Date();
      } else {
        date = new Date(date);
      }

      switch (type) {
        case "y":
          date = moment(date).add(value, 'years').toDate();
          break;
        case "M":
          date = moment(date).add(value, 'months').toDate();
          break;
        case "D":
          date = moment(date).add(value, 'days').toDate();
          break;
        case "h":
          date = moment(date).add(value, 'hours').toDate();
          break;
        case "m":
          date = moment(date).add(value, 'minutes').toDate();
          break;
        case "s":
          date = moment(date).add(value, 'secounds').toDate();
          break;
        default:
          date = moment(date).add(value, 'days').toDate();
      }

      if (utc) {
        return date.toUTCString();
      }
      return date;
    },

    diffDays(date1, date2, type) {
      type = !type ? "d" : type;
      date1 = !date1 ? moment() : moment(date1);
      date2 = !date2 ? moment() : moment(date2);

      switch (type) {
        case "y":
          return date1.diff(date2, "years", true);
          break;
        case "d":
          return date1.diff(date2, "days", true);
          break;
        case "h":
          return date1.diff(date2, "hours", true);
          break;
        case "m":
          return date1.diff(date2, "minutes", true);
          break;
        case "s":
          return date1.diff(date2, "seconds", true);
          break;
        default:
          return date1.diff(date2, "days", true);
          break;
      }

    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });

      return blob;
    },

    download(blobData, filename) {
      FileSaver.saveAs(blobData, filename);

      //var blobUrl = URL.createObjectURL(blobData);
      //window.location = blobUrl;
    },

    utf8_encode(s) {
      return unescape(encodeURIComponent(s));
    },

    utf8_decode(s) {
      return decodeURIComponent(escape(s));
    },

    toMb: function(bytes){

      if(!bytes)return '0 MB';

      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]}`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`

    },

    toString(value){
      if(value == null || value == undefined)return '';

      return value.toString();
    },

    toMd5(text){

			try {
				text = this.toString(text);
				text = md5(text);
				return text;
			} catch (e) {
				return text;
			}
    },
    
    edAlert(_msg,_type,_items){

      _type = (_type ? _type : 'success')

      this.$alert(_msg, 'Atenção', {
        type:_type,
        confirmButtonText: 'OK'
      });
      
    },

    edMsg(_msg,_type){

      _type = (_type ? _type : 'success')
      
      this.$message({
        showClose: true,
        type:_type,
        message: _msg,
      });
    },

    edNotification(_msg,_type){

      _type = (_type ? _type : 'success')
      
      this.$notify({
        showClose: true,
        type:_type,
        message: _msg,
      });
    },

    validateEmail(email){

      email = (email ? email.trim() : null);
      
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
        return true
      }
      return false
    },

    getPreco(value,type){
      if(!value)return null;

      var arr = value.split(',');

      if(arr.length != 2)return null;

      if(type == 'unit')
        return arr[0];
      else 
        return arr[1];
    },
    
    textLimit(value, limit) {

      limit =  (limit ? limit : 100);

      if (value && value.length > limit) {
        return value.substring(0, limit) + "...";
      }

      return value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// fct.vue?6f5c75fb